import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/decision-wheel/pages/CalculatorPage";

export const Route = createFileRoute("/decision-wheel")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/decision-wheel",
      title: m.dw_meta_title(),
      description: m.dw_meta_description(),
      toolName: m.dw_tool_name(),
      faqs: [
        { q: m.dw_faq_q1(), a: m.dw_faq_a1() },
        { q: m.dw_faq_q2(), a: m.dw_faq_a2() },
        { q: m.dw_faq_q3(), a: m.dw_faq_a3() },
        { q: m.dw_faq_q4(), a: m.dw_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
